import Button from '@/components/Button';
import { ButtonVariant } from '@/components/ButtonVariant';
import Modal, {
  ModalContent,
  ModalHeader,
  ModalProps,
} from '@/components/Modal';
import React from 'react';

const ModalInvalidCouponsInfo: React.FC<
  React.PropsWithChildren<ModalProps>
> = ({ id }) => {
  return (
    <Modal id={id}>
      <ModalHeader>
        <span>Das Spielfeld ist unvollständig</span>
      </ModalHeader>
      <ModalContent>
        <p>
          Um den Schein abgeben zu können, muss dieser vervollständigt oder
          gelöscht werden.
        </p>
        <p>
          <Button
            variant={ButtonVariant.Primary}
            fullWidth={true}
            onClick={() => Modal.close(id)}
          >
            OK
          </Button>
        </p>
      </ModalContent>
    </Modal>
  );
};

export default ModalInvalidCouponsInfo;
